import { Link } from "react-router-dom";
import { Icon } from "components";
import { PROJECT, JOB, MILESTONE, RIGHT } from "icons";
import { useMilestone } from "@/modules/work/milestones/context";
import { ROUTE } from "@/lib/utils";

export const MilestoneBreadcrumbs = () => {
  const { milestone } = useMilestone();
  if (!milestone) return null;

  const project = milestone?.job?.project;
  const job = milestone?.job;

  return (
    <nav className="flex items-center text-sm">
      <Link
        to={ROUTE.PROJECT(project?.project_id)}
        className="flex items-center gap-2 px-2 py-1 rounded hover:bg-muted transition-colors"
      >
        <Icon icon={PROJECT} className="size-4 text-muted-foreground" />
        <span className="font-medium truncate max-w-[220px]">
          {project?.name}
        </span>
      </Link>
      <Icon icon={RIGHT} className="text-muted-foreground" />

      <Link
        to={ROUTE.JOB(job?.id)}
        className="flex items-center gap-2 px-2 py-1 rounded hover:bg-muted transition-colors"
      >
        <Icon icon={JOB} className="size-4 text-muted-foreground" />
        <span className="truncate max-w-[220px] font-medium">{job?.name}</span>
      </Link>
      <Icon icon={RIGHT} className="text-muted-foreground" />

      <div className="flex items-center gap-2 px-2 py-1">
        <Icon icon={MILESTONE} className="size-4 text-muted-foreground" />
        <span className="truncate max-w-[260px] font-medium">
          {milestone?.name ?? "Milestone"}
        </span>
      </div>
    </nav>
  );
};
